<template>
  <img
    src="/images/bpor.jpg"
    alt="logo"
    class="cLogo"
    v-bind="$props"
    @click="$emit('click', $event)"
  />
</template>

<script>
export default { props: {} }
</script>

<style scoped>
.cLogo {
  max-height: 150px;
}
</style>
